import { render, staticRenderFns } from "./CustomerProposalService.vue?vue&type=template&id=eb441d0a"
import script from "./CustomerProposalService.vue?vue&type=script&lang=js"
export * from "./CustomerProposalService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports